






















































import Vue from "vue";
import { Component,  Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { AppConstants as _app } from "@/shared/app.constants";
import { Utilities as utils } from "@/shared/utilities";
import { ICommunicationData, ICommunication, ICommunicationReport } from "@/entities";
import ProgressBar from '@/components/common/ProgressBar/ParentChildProgressBar.vue';
import { i18n } from "@/plugins/i18n";

const namespace = 'communication';

@Component({
  components: {
      ProgressBar
}})
export default class CommunicationReportList extends Vue {
    @Prop() reports!: any;
    @Prop() workflowInfo!: any;
    @Getter('statusText', {namespace}) getStatusText!: (id: number, isReturned: number) => string;

    search: string = '';
    headers: any = [];
    actions = _app.actions;
    subjects = _app.subjects;
    selectedReport: any = {};
    ppoAccess:boolean = false;
    initiativeId:number = 0;

    /** mounted fn */
    mounted() {
        this.headers = _app.communicationPeriodHeaders;
        this.headers.map(x => {
            x.text = this.$t(x.text);
        });
    }

    /** format date */
    formatDate(dt: any) {
        return utils.formatDate(dt);
    }

    // TO DO: Get the status text from the workflow steps..
    statusText(status: number, isReturned: boolean) {
        if(isReturned) {
            return `${i18n.t('Returned to Grantee')}`;
        }
        switch(status) {
            case _app.commReportStatus.inProgress: 
                return `${i18n.t('In Progress')}`;
            case _app.commReportStatus.completed:
                return `${i18n.t('Completed')}`;
            default:
                return `${i18n.t('Not Started')}`;
        }
        
    }
}
